import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-satisfaction-config',
  templateUrl: './satisfaction-config.component.html',
  styleUrls: ['./satisfaction-config.component.scss']
})
export class SatisfactionConfigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
